import { getVideos } from "@/api/videos"
export default {
  state: {
    videos: {
      data: []
    },
    currentVideo: null
  },
  mutations: {
    GET_VIDEOS: (state, videos) => {
      state.videos = videos
    },
    SET_CURRENT_VIDEO: (state, video) => {
      state.currentVideo = video
    }
  },
  actions: {
    async getVideos({ commit }, payload) {
      try {
        const response = await getVideos(payload)
        commit("GET_VIDEOS", response)
      } catch (err) {
        console.log("Couldn't fetch videos:\n", err)
      }
    }
  }
}
